import { SET_FORM_DIRTY } from '@pbl/pbl-react-core/lib/models/form-metadata';
import { DispatchMethod } from '../index';

export const setIsFormDirty = (value: boolean) => (dispatch: DispatchMethod) => {
  dispatch({
    type: SET_FORM_DIRTY,
    payload: value
  });
};
